import { createAction, props } from '@ngrx/store';

const GET_ALL_ACL_PERMISSIONS = '[AclPermission] Get All ACL Permissions';
const SET_ACL_PERMISSIONS = '[AclPermission] Set ACL Permissions';
const CREATE_ACL_PERMISSION = '[AclPermission] Create ACL Permission';
const CREATE_ACL_PERMISSION_SUCCESS = '[AclPermission] Create ACL Permission Success';
const CREATE_ACL_PERMISSION_FAILURE = '[AclPermission] Create ACL Permission Failure';
const UPDATE_ACL_PERMISSION = '[AclPermission] Update ACL Permission';
const UPDATE_ACL_PERMISSION_SUCCESS = '[AclPermission] Update ACL Permission Success';
const UPDATE_ACL_PERMISSION_FAILURE = '[AclPermission] Update ACL Permission Failure';
const BATCH_UPDATE_ACL_PERMISSIONS = '[AclPermission] Batch Update ACL Permissions';
const BATCH_UPDATE_ACL_PERMISSIONS_SUCCESS = '[AclPermission] Batch Update ACL Permissions Success';
const BATCH_UPDATE_ACL_PERMISSIONS_FAILURE = '[AclPermission] Batch Update ACL Permissions Failure';
const CLEAR_ACL_PERMISSIONS_STATE = '[AclPermission] Clear ACL Permissions State';

const getAllAclPermissions = createAction(
  GET_ALL_ACL_PERMISSIONS,
  props<{
    apiConstants: any;
    payloadWithPathVariables: {
      generationId: string;
      start: number;
      length: number;
      order: any[];
      removeUrlVariables: string[];
    };
  }>()
);

const setAclPermissions = createAction(SET_ACL_PERMISSIONS, props<{ aclPermissions: any[] }>());

const createAclPermission = createAction(CREATE_ACL_PERMISSION, props<{ apiConstants: any; urlPathVariables: any }>());

const createAclPermissionSuccess = createAction(CREATE_ACL_PERMISSION_SUCCESS, props<{ aclPermission: any }>());

const createAclPermissionFailure = createAction(CREATE_ACL_PERMISSION_FAILURE);

const updateAclPermission = createAction(UPDATE_ACL_PERMISSION, props<{ apiConstants: any; urlPathVariables: any }>());

const updateAclPermissionSuccess = createAction(UPDATE_ACL_PERMISSION_SUCCESS, props<{ aclPermission: any }>());

const updateAclPermissionFailure = createAction(UPDATE_ACL_PERMISSION_FAILURE);

const batchUpdateAclPermissions = createAction(
  BATCH_UPDATE_ACL_PERMISSIONS,
  props<{ apiConstants: any; payload: any[] }>()
);

const batchUpdateAclPermissionsSuccess = createAction(
  BATCH_UPDATE_ACL_PERMISSIONS_SUCCESS,
  props<{ aclPermissions: any[] }>()
);

const batchUpdateAclPermissionsFailure = createAction(BATCH_UPDATE_ACL_PERMISSIONS_FAILURE);

const clearAclPermissionsState = createAction(CLEAR_ACL_PERMISSIONS_STATE);

export const AclpermissionActions = {
  getAllAclPermissions,
  setAclPermissions,
  createAclPermission,
  createAclPermissionSuccess,
  createAclPermissionFailure,
  updateAclPermission,
  updateAclPermissionSuccess,
  updateAclPermissionFailure,
  batchUpdateAclPermissions,
  batchUpdateAclPermissionsSuccess,
  batchUpdateAclPermissionsFailure,
  clearAclPermissionsState
};
